import { Component } from "@angular/core";
import { DynamicDialogRef } from "primeng/dynamicdialog";

@Component({
	template: '<report-builder-starter-ng [primeNgNewReportDialog]="ref"></report-builder-starter-ng>'
})
export class ReportBuilderStarterComponent {
	constructor(
		public ref: DynamicDialogRef
	) { }
}